<p-drawer [(visible)]="isVisible" [modal]="false" position="bottom" [showCloseIcon]="true"
  styleClass="p-0 p-drawer-sm" [style]="{'max-height':'50px', 'background-color':'#F1F3F4'}">
  <ng-template pTemplate="headless">
    <div class="flex justify-between items-center px-3 pt-1 w-full play-carousel">
      <span class="text-sm font-medium">
      {{currentRecording+1}}/{{recordingArray.length}}
      </span>
       <i *ngIf="recordingArray.length > 1"
           class="pi pi-chevron-circle-left cursor-pointer text-xl"
           (click)="playPrevious()"
           [pTooltip]="'Previous'" tooltipPosition="top"></i>

        <i *ngIf="recordingArray.length > 1"
           class="pi pi-chevron-circle-right cursor-pointer text-xl"
           (click)="playNext()"
           [pTooltip]="'Next'" tooltipPosition="top"></i>
    </div>
    <audio id="audio-player" controls style="width: 93%;" (loadeddata)="onLoad($event)" (pause)="onPauseAudio($event)"
      (play)="onPlayAudio($event)" (ended)="onEndAudio($event)">
      <source [src]="audioSrc" type="audio/mpeg" />
    </audio>
    <i class="pi pi-times cursor-pointer close-icon absolute bg-red-600 text-sm p-1 text-white border-circle "
      (click)="closeDialog()" [pTooltip]="'Close'| translate" tooltipPosition="top"></i>
  </ng-template>
</p-drawer>